export default {
  title: 'MTech Settings',
  items: {
    MTechMarkupValue : {
      label: 'Markup Value',
      type: 'integer',
      unit: 'fee'
    },
    MTechMarkupType: {
      label: 'Markup Type',
      type: 'dropdown',
      values: ['$', '%']
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/mtech-settings.js